<script setup>
defineProps({
    tid: {
        type: String,
        required: false,
        default: "",
    },
    text: {
        type: String,
        required: false,
        default: "",
    },
    sentTime: {
        type: String,
        required: false,
        default: "",
    },
    pictureUrl: {
        type: String,
        required: false,
        default: "",
    },
});
</script>

<template>
    <div :data-beacon-tid="tid" class="card p-4 col-12">
        <div class="mb-3 text-muted text-sm">
            <time>
                {{ sentTime }}
            </time>
        </div>
        <div class="row">
            <div class="col-12 col-lg" v-html="text" />
            <div v-if="pictureUrl" class="col-12 col-sm-6 col-md-4 mt-3 mt-lg-0 mx-auto">
                <img :src="pictureUrl" class="w-100">
            </div>
        </div>
    </div>
</template>
